import { render, staticRenderFns } from "./image.vue?vue&type=template&id=7b6a71ae&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"
import style0 from "./image.vue?vue&type=style&index=0&id=7b6a71ae&scoped=true&lang=css&"
import style1 from "./image.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a71ae",
  null
  
)

export default component.exports